import { convertStatus } from '@components/learningPath/utils';
import { ContentType, Tag } from 'learning-panel-components';
import { coreService } from 'network-utils';

const convertLearningPathToContentCard = (learningPath: coreService.LearningPath) => {
    return {
        type: 'learningPath' as keyof typeof ContentType,
        uuid: learningPath.uuid,
        name: learningPath.name,
        description: learningPath.description,
        tagline: learningPath.description,
        level: learningPath.level,
        completionDate: learningPath.progress?.completedAt,
        timeOrDate: String(learningPath.duration),
        potentialScore: learningPath.potentialScore,
        status: convertStatus(learningPath.progress?.status) || 'notStarted',
        cardUrl: `/app/learningPath?uuid=${learningPath.uuid}`,
        imageUrl: `${process.env.PUBLIC_URL}/images/learningPathCard.svg`,
        displayName: learningPath.name,
        dueDate: learningPath.dueDate ? new Date(learningPath.dueDate) : undefined,
        tags: learningPath?.tags?.map((tag: any) => tag.displayName)
    };
};

export default convertLearningPathToContentCard;
